import { AppClient } from './client';
import { AppEnvironment, BRAND_DEFAULTS, CLIENT_FLAG_DEFAULTS } from './app-environment';

export const environment: AppEnvironment = {
  onlyOfficeServerUrl: AppClient.OPENOFFICE_URL_QA,
  production: true,
  baseUrl: '/app',
  baseUrlws: '/sock',
  videoFeedApi: '/videoFeed',
  videoMergeFeed: '/videoMerge',
  gpuProctoringUrl: '/gpu',
  gpuQueueStatusUrl: '/proctorQueue',
  videoProctoringMachineId: '84065140264278613',
  VAPI_INTERVIEW_AGENT_ASSISTANT_ID: '3c592f00-d49a-470a-b241-a0f99379b6c5',
  VAPI_INTERVIEW_AGENT_LATERAL_ASSISTANT_ID:
    '447441ce-9caf-4e17-8080-19899cb5abcf',
  VAPI_INTERVIEW_AGENT_IMAGINEER_ASSISTANT_ID:
    '4cfd3cec-c5b7-43a2-995b-fc91fcff6b7b',
  VAPI_INTERVIEW_AGENT_PRACTICE_ASSISTANT_ID:
    '3e761da4-d842-46d0-b612-017ce3768896',
  DOWNLOADAPP: 'https://f360.foyr.com/app-entry-page',
  DESKTOP_IQIGAI_LITE: false,
  STATIC_OTP: 123456,

  deployedClient: AppClient.QA_MAIN,

  appUrl: AppClient.URL_QA_MAIN,
  enableSentry: true,
  brand: BRAND_DEFAULTS,
  // Per-client customisation flags: standard defaults. A specific client's
  // environment.<client>.ts overrides only what it changes. See app-environment.ts.
  ...CLIENT_FLAG_DEFAULTS,
};
